<script>
  import ProductListTopLeftBadge from '@/components/ProductListTopLeftBadge.vue';
  import ProductListBottomPillBadge from '@/components/ProductListBottomPillBadge.vue';
  import ProductListTextUnderBadge from '@/components/ProductListTextUnderBadge.vue';

  let heightIsAdjusted = false;

  export default {
    components: {
      ProductListTopLeftBadge,
      ProductListBottomPillBadge,
      ProductListTextUnderBadge
    },
    name: 'ProductGridItemBadges',
    data() {
      return {
        tags: [],
        badgeType: '',
        price: 0
      };
    },
    mounted() {
      this.initializeBadges();
    },
    methods: {
      initializeBadges() {
        const parentElement = this.$el?.parentElement;
        if (!parentElement) {
          return;
        }

        this.badgeType = parentElement.getAttribute('data-badge-type') || '';
        const tags = parentElement.getAttribute('data-product-tags');
        this.tags = tags ? JSON.parse(tags) : [];
        const price = parentElement.getAttribute('data-product-price');
        this.price = price ? parseFloat(price) : 0;

        if (document.body.classList.contains('template-product')) {
          const $recentlyViewedFlkty = document.querySelector('.recent__content');
          if ($recentlyViewedFlkty && $recentlyViewedFlkty.children.length && !heightIsAdjusted) {
            this.$nextTick(() => {
              const $recentFlktyViewPort = $recentlyViewedFlkty.querySelector('.flickity-viewport');
              const $productGridPromoBadge = $recentlyViewedFlkty.querySelectorAll('.promo-badge')[0];
              if (!$productGridPromoBadge) return;

              const newHeight = `${parseFloat(window.getComputedStyle($recentFlktyViewPort).height) + $productGridPromoBadge.offsetHeight}px`;
              $recentFlktyViewPort.style.height = newHeight;
            });
            heightIsAdjusted = true;
          }
        }
      }
    }
  };
</script>

<template>
  <component :is="badgeType" :tags="tags" :price="price" v-if="badgeType !== ''" />
</template>
